import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { name, reducer, actions } from './slice';
import saga from './saga';

export default function usePackagesBySearchCode() {
  const dispatch = useDispatch();
  useInjectReducer({ key: name, reducer });
  useInjectSaga({ key: name, saga });
  useEffect(() => {
    return function cleanUp() {
      dispatch(actions.reset());
    };
  }, [dispatch]);
}
